// extracted by mini-css-extract-plugin
export var colorSquare = "_m8-0";
export var danger = "_m8-5";
export var lightPink = "_m8-8";
export var neutralBlue = "_m8-7";
export var neutralYellow = "_m8-6";
export var normal = "_m8-1";
export var primary = "_m8-2";
export var primaryLight = "_m8-3";
export var solidBlack = "_m8-g";
export var solidGreen = "_m8-b";
export var solidLightBlue = "_m8-d";
export var solidNavy = "_m8-c";
export var solidOrange = "_m8-f";
export var solidPink = "_m8-e";
export var solidRed = "_m8-9";
export var solidYellow = "_m8-a";
export var success = "_m8-4";